import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common'; 
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {CoreModule} from './core/core.module';
import {HttpClientModule, HttpClientXsrfModule} from '@angular/common/http';
import { ViewEconomicOperatorComponent } from './modules/economic-operators/pages/view-economic-operator/view-economic-operator.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpClientXsrfModule,
    CoreModule,
    AppRoutingModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy }  // Use HashLocationStrategy
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}


